import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./dealsAndOffers.css";
import ListDeals from "../Deals/listDeals";
import ListCoupons from "../Coupons/listCoupons";
import ListAds from "../Ads,Banners/listAds";
import { Skeleton } from "antd";

const STORAGE_KEY = "coupon_header_tab";

const DealsAndOffer = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "create_coupons"
  );

  const [loading, setLoading] = useState(false);

  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;


    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className="bg-white border-10 padding-10 shadow-box">
          <div className="hover_panel">
            <h4
              className={selectedTable === "create_coupons" ? "clicked" : ""}
              onClick={() => handleTableSelection("create_coupons")}
            >
              Coupons
            </h4>
            <h4
              className={selectedTable === "AdsAndBanner" ? "clicked" : ""}
              onClick={() => handleTableSelection("AdsAndBanner")}
            >
              Ads & Banner
            </h4>
            <h4
              className={selectedTable === "deals" ? "clicked" : ""}
              onClick={() => handleTableSelection("deals")}
            >
              Deals
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }} className="fade-wrapper">
          <div
            className="fade-tab"
            style={{ display: selectedTable === "create_coupons" ? "block" : "none" }}
          >
            <ListCoupons />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "deals" ? "block" : "none" }}
          >
            <ListDeals />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "AdsAndBanner" ? "block" : "none" }}
          >
            <ListAds />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DealsAndOffer;
